import { render, staticRenderFns } from "./CentreBanner.vue?vue&type=template&id=9489ff9c&scoped=true&"
import script from "./CentreBanner.vue?vue&type=script&lang=js&"
export * from "./CentreBanner.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9489ff9c",
  null
  
)

export default component.exports